export default class EmbedCode {
  setup() {
    $(document).on('click', '.map-actions-container [data-action="toggle-embed-code"]', (e) => {
      const container = $(e.currentTarget).parents('.map-actions-container');
      container.toggleClass('code-expanded');
    })
  };
}
